<table style="width: 100%">
  <th></th>
  <tr *ngFor="let d of data" [style.background-color]="d.changed ?  '#ffa50050' : 'white'">
    <td>{{d.key | removeUnderscore | upperfirst}}</td>
    <td style="white-space: pre-wrap;">{{d.value | json}}</td>
  </tr>
</table>